import { COUNTRY_COLLECTION_NAME, LANGUAGE_COLLECTION_NAME } from 'models';
import { InputFromCollection } from 'components/settings/recordList';
import { Button, Cancel } from 'components/button';

import './countryAndLanguage.css';

export interface CountryAndLanguageProps {
    countryIndexId: string;
    setCountryIndexId: (_: string) => void;
    languageIndexId: string;
    setLanguageIndexId: (_: string) => void;
    onSave: () => void;
    onCancel: () => void;
}
export const CountryAndLanguage = ({
    countryIndexId,
    setCountryIndexId,
    languageIndexId,
    setLanguageIndexId,
    onSave,
    onCancel,
}: CountryAndLanguageProps) => {
    return (
        <div>
            <div className="formLabel">Add a Country and a Language</div>
            <div className="formInputs">
                <form>
                    <div>
                        <div className="label">Country*</div>
                        <InputFromCollection
                            collectionName={COUNTRY_COLLECTION_NAME}
                            value={countryIndexId}
                            onSelect={(value) => setCountryIndexId(value || '')}
                        />
                    </div>
                    <div>
                        <div className="label">Language*</div>
                        <InputFromCollection
                            collectionName={LANGUAGE_COLLECTION_NAME}
                            value={languageIndexId}
                            onSelect={(value) => setLanguageIndexId(value || '')}
                        />
                    </div>
                </form>
            </div>
            <div className="formButtons">
                <Cancel onClick={() => onCancel()} />
                <Button style={{ width: '149px' }} onClick={() => onSave()}>
                    Save
                </Button>
            </div>
        </div>
    );
};
